import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';


// Redux
import { FullEngagements, isEngaged } from './redux/userengagement.selectors';
import { toggleEngagement, searchEngagements, useEngagement } from './redux/userengagement.actions';
import { StyledButton } from '../../../styles/matieralui/Button';
import { IconFavoriteFilled, IconFavoriteOutlined, IconSaveFilled, IconSaveOutlined } from '../../Icons';
import { StyledIconButton } from '../../../styles/matieralui/IconButton';



export const Save = ({ modelId, modelType }) => {


    // State
    const dispatch = useDispatch();
    const store = FullEngagements();
    const liked = isEngaged(store, modelId, modelType, 'save');

    // New Way
    // const { loading, engagements } = useEngagement({ modelId, modelType });
    // console.log(store, "store - save")

    // Load Favorites
    // useEffect(() => {

    //     // Load all favorites by type only if we haven't loaded them already.
    //     if (store?.itemsLoading === true) return; // Wait until the load finishes
    //     if (!store?.items?.count || store?.items?.count <= 1) {
    //         dispatch(searchEngagements(0, 999, null, null, {}));
    //     }

    // }, [modelId, modelType])

    const handleFavoriteClick = () => {
        if (store?.itemsLoading === true) return;
        if (store?.createLoading === true) return;
        // Toggle Favorite
        dispatch(toggleEngagement({ modelId, modelType, engagement: 'save' }))
    }


    return (
        <StyledIconButton onClick={handleFavoriteClick}>
            {!liked ? (<IconSaveOutlined />) : (<IconSaveFilled />)}
        </StyledIconButton>
    )
}